module.exports = __webpack_public_path__ + "img/icon-time.849f481c.png";